import {
  client,
  ClustersControllerListSummariesData,
  ClusterSummaryDto,
} from "@/client";
import { isDefined } from "@/lib/utils";
import { createTableContext } from "@/components/custom/data-table/data-table-context";
import { useColumns } from "./-clusters-columns.tsx";
import { OpenAPI } from "@/client";

export const ClustersTableContext = createTableContext<
  ClusterSummaryDto,
  ClustersControllerListSummariesData
>({
  queryArgument: () => ({ page: 1, limit: 10 }),
  getRowId: (row) => {
    if (isDefined(row?.id)) {
      return `${row.id}`;
    }
    console.warn("undefined row.id", row);
    return ``;
  },
  queryCreator: client.clusters.listSummaries.asQueryOptions,
  columns: useColumns,
  searchField: "name",
  searchLabel: "Cluster Name",

  downloadCsv: {
    url: () => `${OpenAPI.BASE}/api/v2/dashboard/clusters/download`,
    fileName: "clusters",
    permission: (permissions) => permissions.clusters.download,
  },
});
